<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Woordpad" [steps]="path().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    <rid-mechanic-title [title]="'Vervang een klank of voeg een klank toe'" />

    <!-- assignment -->
    <div class="isolate flex flex-col items-center gap-16">
      <rid-vertical-spacer>
        <rid-option
          [option]="{
            type: 'CONTENT',
            layout: 'HORIZONTAL',
            image: path()[0].image,
          }"
        />
      </rid-vertical-spacer>
      <rid-vertical-spacer>
        <rid-klank-card klank="x" />
      </rid-vertical-spacer>

      @for (input of [assignment()]; track input.id) {
        <div class="absolute flex flex-col items-center gap-16" animate.leave="anim-fade-out">
          <rid-option
            #optionComp
            [option]="{
              type: 'CONTENT',
              layout: 'HORIZONTAL',
              image: input.prompt.image,
              audio: input.prompt.audio,
            }"
            animate.enter="wait-500 anim-pop-in"
            ridSfx="BUBBLE_POP"
            (animationend)="$event.animationName === 'pop-in' ? present(optionComp) : undefined"
          />
          <div class="flex justify-center gap-2">
            <rid-vertical-spacer>
              <rid-klank-card klank="x" />
            </rid-vertical-spacer>
            @if (input.showOptions) {
              <div class="absolute flex gap-2">
                @for (option of input.options; track option.id) {
                  <rid-draggable
                    [class.opacity-0]="option.consumed"
                    [grabbable]="dragIndex() === undefined && !input.completed"
                    animate.enter="anim-pop-in"
                    [style.animation-delay.ms]="$index * 50"
                    ridSfx="BUBBLE_POP"
                    (started)="grabbed($index)"
                    (moved)="onDragMove($event[0], $event[1])"
                    (released)="release()"
                  >
                    <rid-klank-card
                      [klank]="option.klank"
                      [disabled]="(dragIndex() !== undefined && $index !== dragIndex()) || input.completed"
                    />
                  </rid-draggable>
                }
              </div>
            }
          </div>
        </div>
      }
      @let _target = target();
      <rid-text-input class="min-w-2xl">
        <div class="flex place-content-center">
          <!-- spacer -->
          <rid-vertical-spacer>
            <rid-klank-card [klank]="'x'" />
          </rid-vertical-spacer>

          <rid-word-path-gap #gapComps [isWide]="wideGaps()" [attr.data-drop-kind]="'GAP'" [attr.data-drop-index]="-1" />
          @for (klank of word(); track klank.id) {
            <rid-word-path-klank
              #klankComps
              [klank]="klank.klank"
              [klankId]="klank.klankId"
              [isPendingRemoval]="_target?.kind === 'CARD' && _target?.index === $index"
              [pendingNeighbor]="
                _target?.kind === 'GAP' && _target?.index === $index - 1
                  ? 'BEFORE'
                  : _target?.kind === 'GAP' && _target?.index === $index
                    ? 'AFTER'
                    : undefined
              "
              [attr.data-drop-kind]="'CARD'"
              [attr.data-drop-index]="$index"
            />
            <rid-word-path-gap #gapComps [isWide]="wideGaps()" [attr.data-drop-kind]="'GAP'" [attr.data-drop-index]="$index" />
          }
        </div>
      </rid-text-input>
    </div>

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
